import ListingVM from './listing-vm';
import Vue from 'vue'
import 'libs/vue-extensions'

export default {
  init(node) {
    const data = JSON.parse(node.dataset.programsData)
    ko.applyBindings(new ListingVM(data, node), node)
    new Vue({ el: node, data: { programs: data.programs } })
  }
}
